import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext, useContext } from 'react';
import { useScroll } from "./hooks/useScroll";
var ScrollContext = /*#__PURE__*/createContext({
  scrollToBottom: function scrollToBottom() {},
  containerRef: {
    current: null
  },
  isScrollButtonVisible: false,
  scrollRef: {
    current: null
  },
  containerHeight: 0,
  scrollHeight: 0,
  onListMount: function onListMount() {}
});
export var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children,
    params = _objectWithoutProperties(_ref, _excluded);
  var value = useScroll(params);
  return /*#__PURE__*/React.createElement(ScrollContext.Provider, {
    value: value
  }, children);
};
export var useScrollContext = function useScrollContext() {
  return useContext(ScrollContext);
};